import React from 'react';
import { Provider } from "./components/ui/provider"
import ReactDOM from 'react-dom/client';
import './index.css';
import './App.css';
import './myCss.css';
import './dsCSS.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider>
  <App />
</Provider>
);

